import { createContext } from 'react';

export const articleSearchContext = createContext<[string, React.Dispatch<React.SetStateAction<string>>]>(['', () => { throw new Error("you're not in a article search context"); }]);
